import { getCookie, setCookie, updateCookie, text_truncate, getBrowserType } from '../core/utils.js';

var code = '',
  ccode = '',
  leads_referrer = document.referrer;

export function trialButton() {

  var links = document.querySelectorAll('a');
  // Loop melalui elemen yang ditemukan
  links.forEach(link => {
    if (link.href.includes('https://omni.desty.app/register') || link.href.includes('https://admin-test.desty.one/register')) {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        // if($(window).width() > 1024) {
        // e.stopImmediatePropagation();

        var $url = this.href;
        requestAnimationFrame(() => {
          document.querySelectorAll('.has-loading').forEach(el => {
            el.style.display = 'flex';
          });
        });
        // const newTab = window.open(window.location.origin + '/loading/', '_blank');

        var browserType = getBrowserType();

        var url_string = window.location.href;
        var url = new URL(url_string);

        var devicetype = 'Desktop';

        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
          devicetype = 'Mobile';
        } else {
          devicetype = 'Desktop';
        }

        var click_date = new Date();
        var click_DD = (click_date.getDate() < 10 ? '0' : '') + click_date.getDate();
        var click_MM = ((click_date.getMonth() + 1) < 10 ? '0' : '') + parseInt(click_date.getMonth() + 1);
        var click_YY = click_date.getFullYear().toString().slice(2);
        var click_hh = (click_date.getHours() < 10 ? '0' : '') + click_date.getHours();
        var click_mm = (click_date.getMinutes() < 10 ? '0' : '') + click_date.getMinutes();
        var click_ss = click_date.getSeconds();
        var click_ms = click_date.getMilliseconds();
        var click_sh = click_DD + click_MM + click_YY + click_hh + click_mm + click_ss + click_ms;
        var gclid = url.searchParams.get("gclid") || getCookie('gclid') || '';
        var msclkid = url.searchParams.get("msclkid") || getCookie('msclkid') || '';
        var umedium = url.searchParams.get("utm_medium") || getCookie('utm_medium') || '';
        var ucampaign = url.searchParams.get("utm_campaign") || getCookie('utm_campaign') || '';
        var usource = url.searchParams.get("utm_source") || getCookie('utm_source') || '';
        var utm_term = url.searchParams.get("utm_term") || getCookie('utm_term') || '';
        var matchtype = url.searchParams.get("matchtype") || getCookie('matchtype') || '';
        var banner_journey = getCookie('banner_journey') || '';
        var cta_journey = getCookie('cta_journey') || '';
        var cta_last_click = getCookie('cta_last_click') || '';
        var medium_code = getCookie('waba_code') || '';
        var campaign_code = getCookie('medium_code') || '';
        var query_keyword = url.searchParams.get("query") || getCookie('query_keyword') || 'null';

        var f_gclid_short = document.querySelector('#f_gclid_short'),
          f_gclid = document.querySelector('#f_gclid'),
          f_device = document.querySelector('#f_device'),
          f_utmsource = document.querySelector('#f_utmsource'),
          f_utmmedium = document.querySelector('#f_utmmedium'),
          f_utmcampaign = document.querySelector('#f_utmcampaign'),
          f_utmterm = document.querySelector('#f_utmterm'),
          f_banner_id = document.querySelector('#f_banner_id'),
          f_gclid_journey = document.querySelector('#f_gclid_journey'),
          f_matchtype = document.querySelector('#f_matchtype'),
          f_journey = document.querySelector('#f_journey'),
          f_gaid = document.querySelector('#f_gaid'),
          f_waba_medium = document.querySelector('#f_waba_medium'),
          f_browser = document.querySelector('#f_browser'),
          f_referrer = document.querySelector('#f_referrer'),
          f_label = document.querySelector('#f_label'),
          f_query_keyword = document.querySelector('#f_query_keyword'),
          f_visitor_id = document.querySelector('#f_visitor_id');

        if (f_gclid_short) {
          f_gclid_short.setAttribute('value', click_sh);
        }

        if (f_gclid) {
          f_gclid.setAttribute('value', text_truncate(`${gclid}|${msclkid}`, 250, ''));
        }

        if (f_utmsource) {
          f_utmsource.setAttribute('value', usource)
        }

        if (f_utmmedium) {
          f_utmmedium.setAttribute('value', umedium)
        }

        if (f_utmcampaign) {
          f_utmcampaign.setAttribute('value', ucampaign)
        }

        if (f_utmterm) {
          f_utmterm.setAttribute('value', utm_term)
        }

        if (f_matchtype) {
          f_matchtype.setAttribute('value', matchtype)
        }

        if (f_banner_id) {
          f_banner_id.setAttribute('value', banner_journey);
        }

        if (f_query_keyword) {
          f_query_keyword.value = query_keyword;
        }

        var label = "";

        // Get CTA ID and Label
        if (this.classList.contains('ic-wa')) {
          label = 'ID: ' + this.id + ', Label: Sticky WABA';
        } else if (this.classList.contains('top-banner-sticky') || this.classList.contains('top-banner-bot')) {
          label = 'ID: ' + this.id + ', Label: Sticky Banner';
        } else if (this.id != '') {
          label = 'ID: ' + this.id + ', Label: ' + this.innerText;
        } else {
          label = 'ID: , Label: ' + this.innerText;
        }

        var cta_journey_temp = '';
        if (cta_journey != '') {
          if (cta_last_click != '') {
            if (cta_last_click != this.id) {
              cta_journey_temp = cta_journey + '|' + label;
            } else {
              cta_journey_temp = cta_journey;
            }
          } else {
            cta_journey_temp = label;
          }
        } else {
          cta_journey_temp = label;
        }

        if (f_label) f_label.value = cta_journey_temp;

        if (getCookie('cta_journey')) {
          updateCookie('cta_journey', cta_journey_temp);
        } else {
          setCookie('cta_journey', cta_journey_temp, 31);
        }

        if (getCookie('cta_last_click')) {
          updateCookie('cta_last_click', this.id);
        } else {
          setCookie('cta_last_click', this.id, 31);
        }

        if (f_gclid_journey) {
          f_gclid_journey.setAttribute('value', (getCookie('gclid_journey') ? getCookie('gclid_journey') : ''));
        }

        if (f_device) {
          f_device.setAttribute('value', devicetype);
        }

        var form_waba = document.querySelector('#form_shortener_gclid');
        if (form_waba) {

          if (f_journey) {
            var limit_journey = text_truncate(getCookie('user_journey'), 250, '');
            f_journey.setAttribute('value', limit_journey);
          }

          if (f_gaid) {
            if (getCookie('gaid')) {
              f_gaid.setAttribute('value', getCookie('gaid'));
            } else {
              if (getCookie('_ga')) {
                f_gaid.setAttribute('value', getCookie('_ga').slice(6));
              }
            }
          }

          var modifiedCampaign = '[Req.P' + click_sh + ']';
          var campaignInfo = JSON.parse('{"gclid":"' + (getCookie('gclid') ? getCookie('gclid') : '') + '", "utm_source":"' + (getCookie('utm_source') ? getCookie('utm_source') : '') + '", "utm_medium":"' + (getCookie('utm_medium') ? getCookie('utm_medium') : '') + '", "utm_campaign":"' + modifiedCampaign + '"}');

          const stringifyCampaignInfo = JSON.stringify(campaignInfo)
          const cookiesCampaignInfo = encodeURIComponent(stringifyCampaignInfo)

          if (getCookie('created_at')) {
            updateCookie('campaign_info', cookiesCampaignInfo);
            updateCookie('j_campaign_info', cookiesCampaignInfo);
          } else {
            setCookie('campaign_info', cookiesCampaignInfo, 31);
            setCookie('j_campaign_info', cookiesCampaignInfo, 31);
          }

          // rulerAnalyticsTracker("Req.T" + click_sh, 'Trial Click Button');

          var f_browser = document.querySelector('#f_browser');
          if (f_browser) {
            f_browser.value = browserType;
          }

          var f_waba_medium = document.querySelector('#f_waba_medium');
          if (f_waba_medium) {
            if (medium_code) {
              f_waba_medium.setAttribute('value', medium_code);
            }

          }

          if (getCookie('lead_referrer')) {
            var f_referrer = document.querySelector('#f_referrer');
            if (f_referrer) {
              f_referrer.value = getCookie('lead_referrer');
            }
          }

          if (f_visitor_id) {
            f_visitor_id.value = getCookie('visitor_id') || '';
          }

          // Get param values from form fields
          // Ambil gclid dan msclkid dari f_gclid.value (format: gclid|msclkid)
          var gclidRaw = f_gclid ? f_gclid.value : '';
          var gclidSplit = gclidRaw.split('|');
          var gclidVal = gclidSplit[0] ? gclidSplit[0].trim() : '';
          var msclkidVal = gclidSplit[1] ? gclidSplit[1].trim() : '';
          var utmSourceVal = f_utmsource ? f_utmsource.value : '';
          var utmMediumVal = f_utmmedium ? f_utmmedium.value : '';
          var utmCampaignVal = modifiedCampaign ? modifiedCampaign : '';
          var utmTermVal = f_utmterm ? f_utmterm.value : '';
          var matchtypeVal = f_matchtype ? f_matchtype.value : '';

          var urlObj = new URL(this.href);
          if (gclidVal) urlObj.searchParams.set('gclid', gclidVal);
          if (msclkidVal) urlObj.searchParams.set('msclkid', msclkidVal);
          if (utmSourceVal && utmSourceVal.trim() !== '') urlObj.searchParams.set('utm_source', utmSourceVal);
          if (utmMediumVal && utmMediumVal.trim() !== '') urlObj.searchParams.set('utm_medium', utmMediumVal);
          if (utmCampaignVal && utmCampaignVal.trim() !== '') urlObj.searchParams.set('utm_campaign', utmCampaignVal);
          if (utmTermVal && utmTermVal.trim() !== '') urlObj.searchParams.set('utm_term', utmTermVal);
          if (matchtypeVal && matchtypeVal.trim() !== '') urlObj.searchParams.set('matchtype', matchtypeVal);
          // console.log(browserType);
          if (browserType === 'Apple Safari (iOS)') {
            // console.log('masuk sini');
            // Buka tab kosong
            const newTab = window.open('about:blank', '_blank');

            // Jika tab berhasil dibuka, ganti URL setelah jeda
            if (newTab) {
              setTimeout(() => {
                newTab.location.href = urlObj.href;
              }, 200); // Jeda 200ms untuk memastikan tab terbuka
            }
          } else {
            // console.log('masuk situ');
            window.open(urlObj.href, '_blank').focus();
          }

          const scriptURL = 'https://script.google.com/macros/s/AKfycbyl_tc3GyekIubqfx5yJPYRoK8lk9T_uSruxs-JKq_nDN0vZnevb6GpJzB9VJeZJErtBg/exec';
          const form = document.forms['form-shortener-gclid'];

          fetch(scriptURL, { method: 'POST', body: new FormData(form) })
            .then(response => {
              if (response.status == 200) {
                requestAnimationFrame(() => {
                  document.querySelectorAll('.has-loading').forEach(el => {
                    el.style.display = 'none';
                  });
                });
              } else {
                console.error('Response code : ', response.status);
                requestAnimationFrame(() => {
                  document.querySelectorAll('.has-loading').forEach(el => {
                    el.style.display = 'none';
                  });
                });
              }
            })
            .catch(error => {
              requestAnimationFrame(() => {
                document.querySelectorAll('.has-loading').forEach(el => {
                  el.style.display = 'none';
                });
              });
            });
        }
      });
    }

  });
}